import { render, staticRenderFns } from "./zebra.vue?vue&type=template&id=0d1554e0&scoped=true&"
import script from "./zebra.vue?vue&type=script&lang=js&"
export * from "./zebra.vue?vue&type=script&lang=js&"
import style0 from "./zebra.vue?vue&type=style&index=0&id=0d1554e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1554e0",
  null
  
)

export default component.exports